module.exports = __webpack_public_path__ + "17-o1.jpg?e43918f93551badef7aa7f6f968a48cc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/quiz/questions/17-o1.jpg
// module id = 632
// module chunks = 0